import { FuseNavigation } from '@fuse/types';

export const navigation: FuseNavigation[] = [
    {
        id       : 'securityu',
        title    : 'Menú de Seguridad',
        // translate: 'NAV.APPLICATIONS',
        type     : 'collapsable',
        // children : [
        //     {
        //         id       : 'users',
        //         title    : 'Cuentas de Usuario',
        //         // translate: 'NAV.USERS',
        //         type     : 'item',
        //         icon     : 'account_box',
        //         url      : '/apps/security/accounts'
        //     },
        //     {
        //         id       : 'features',
        //         title    : 'Características',
        //         // translate: 'NAV.FEATURES',
        //         type     : 'item',
        //         icon     : 'screen_share',
        //         url      : '/apps/security/features'
        //     },
        //     {
        //         id       : 'groups',
        //         title    : 'Grupos',
        //         // translate: 'NAV.GROUPS',
        //         type     : 'item',
        //         icon     : 'account_box',
        //         url      : '/apps/security/groups'
        //     }
        // ]
    }

];
